import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useAnalytics } from 'modules/enps/pages/ResultsPage/useAnalytics'
import type { AnalyticQuestionGroup } from 'modules/enps/store/models/AnalyticResult'
import type AnalyticResult from 'modules/enps/store/models/AnalyticResult'

import QuestionHeadCell from './QuestionHeadCell'
import Row from './Row'

const TableResults = () => {
  const { answeredResults, analyticResults } = useAnalytics()
  const askedQuestions = analyticResults.numeric[0] as AnalyticResult

  const tableHeaders = [i18n.t('enps.results.score_reason'), i18n.t('enps.results.score_range')]

  return (
    <Box>
      <Table style={{ minWidth: '100%', width: 'min-content' }}>
        <Table.Head>
          <Table.Row>
            {tableHeaders.map((title: string) => (
              <QuestionHeadCell key={title} label={title} />
            ))}
            <QuestionHeadCell key={3} label="Type" />
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {answeredResults.map((questionGroup: AnalyticQuestionGroup) => {
            return (
              <Row
                key={questionGroup.id}
                answers={questionGroup.answers}
                questionIds={askedQuestions.questionIds}
              />
            )
          })}
        </Table.Body>
      </Table>
    </Box>
  )
}

export default observer(TableResults)
